// RFC 4180 CSV parser for small client-side imports (YTD import). Handles
// quoted fields with embedded commas, doubled quotes and line breaks, and
// CRLF or LF row endings. Returns an array of rows (arrays of strings);
// rows that are entirely blank are dropped.
export function parseCsv(text) {
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;
  const src = String(text || '').replace(/^﻿/, '');

  for (let i = 0; i < src.length; i += 1) {
    const ch = src[i];
    if (inQuotes) {
      if (ch === '"') {
        if (src[i + 1] === '"') { field += '"'; i += 1; } else { inQuotes = false; }
      } else {
        field += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      row.push(field); field = '';
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && src[i + 1] === '\n') i += 1;
      row.push(field); field = '';
      rows.push(row); row = [];
    } else {
      field += ch;
    }
  }
  if (field !== '' || row.length) { row.push(field); rows.push(row); }
  return rows.filter((r) => r.some((v) => v.trim() !== ''));
}

// Header row -> objects keyed by trimmed header, values trimmed.
export function parseCsvObjects(text) {
  const [header, ...body] = parseCsv(text);
  if (!header) return { headers: [], rows: [] };
  const headers = header.map((h) => h.trim());
  const rows = body.map((vals) => {
    const obj = {};
    headers.forEach((h, i) => { obj[h] = (vals[i] ?? '').trim(); });
    return obj;
  });
  return { headers, rows };
}
